import { Component } from '@angular/core';
import { IonicPage, ModalController, ToastController, NavController, LoadingController } from 'ionic-angular';

import { WorkflowApproval, GlobalVarApproval } from '@providers/index';
import { ListTaskPageApproval } from '..';

// @IonicPage()
@Component({
  selector: 'page-monitoring',
  templateUrl: 'monitoring.html'
})
export class MonitoringPage {
  listWorkflow = [];

  constructor(
    public navCtrl: NavController,
     public workflow: WorkflowApproval,
     public globalvar:GlobalVarApproval,
     public toastCtrl: ToastController,
     public modalCtrl: ModalController,
     public loadingCtrl: LoadingController
    ) {
   
  }

  doRefresh(refresher) {
    refresher.complete();
    this.get_data();
  }

  get_data(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params = {
      User_ID : this.globalvar.app_user.user_attribute.id
    };
    this.workflow.get_monitoring(params).subscribe((resp:any) => {
      this.listWorkflow = resp.data;
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }



  /**
   * The view loaded, let's query our items for the list
   */
  ionViewDidEnter() {
    this.get_data();
  }
 
  /**
   * Navigate to the detail page for this item.
   */
  selectWF(workflow) {
    this.navCtrl.push(ListTaskPageApproval, {
      workflow: workflow,
      is_mytask: 0
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/aproval_erp/monitoring/monitoring.ts